import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

/*
import * as signalR from '@microsoft/signalr';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private hubConnection: signalR.HubConnection;
  private userCountSource = new BehaviorSubject<number>(0);
  userCount$ = this.userCountSource.asObservable();

  private yagnaSeatUpdatedSource = new Subject<void>();
  yagnaSeatUpdated$ = this.yagnaSeatUpdatedSource.asObservable();

  constructor(private http: HttpClient) {}

  public startConnection(token: string): void {
    if (this.hubConnection && this.hubConnection.state === signalR.HubConnectionState.Connected) {
      console.log('Connection already established.');
      this.subscribeToEvents();
      return;
    }

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.apiUrl}/Authenticate/userCountHub`, {
        accessTokenFactory: () => token,
        withCredentials: false
      })
      .withAutomaticReconnect()
      .build();

    this.subscribeToEvents();

    this.hubConnection.start()
      .then(() => {
        console.log('SignalR connection started successfully.');
      })
      .catch(err => console.error('Error while starting connection: ' + err));
  }

  private subscribeToEvents(): void {
    if (!this.hubConnection) {
      console.warn('Cannot subscribe to events: hubConnection is not initialized');
      return;
    }

    this.hubConnection.off('UpdateUserCount');
    this.hubConnection.off('YagnaSeatUpdated');

    this.hubConnection.on('UpdateUserCount', (count: number) => {
      this.userCountSource.next(count);
    });

    this.hubConnection.on('YagnaSeatUpdated', () => {
      console.log('YagnaSeatUpdated event received from SignalR');
      this.yagnaSeatUpdatedSource.next();
    });
  }
}
*/

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private userCountSource = new BehaviorSubject<number>(0);
  userCount$ = this.userCountSource.asObservable();

  private yagnaSeatUpdatedSource = new Subject<void>();
  yagnaSeatUpdated$ = this.yagnaSeatUpdatedSource.asObservable();

  public startConnection(_token: string): void {
    console.info('SignalR live user count is disabled.');
  }

  private subscribeToEvents(): void {
    // SignalR live updates are disabled temporarily.
  }
}
